import Vue from 'vue'
import Router from 'vue-router'
import VueResource from 'vue-resource'
import Index from '@/components/Index'
import Search from '@/components/Search'

Vue.use(Router)
Vue.use(VueResource)

export default new Router({
  mode: 'history',
  fallback: false,
  routes: [
    {
      path: '/en/search',
      name: 'Search-EN',
      component: Search,
      props: { lang: 'en' }
    },
    {
      path: '/nl/search',
      name: 'Search-NL',
      component: Search,
      props: { lang: 'nl' }
    },
    {
      path: '/fr/search',
      name: 'Search-FR',
      component: Search,
      props: { lang: 'fr' }
    },
    {
      path: '/fr/accessoires',
      name: 'Accessories-FR',
      component: Index,
      props: { lang: 'fr', gender: 'accessories' }
    },
    {
      path: '/nl/accessoires',
      name: 'Accessories-NL',
      component: Index,
      props: { lang: 'nl', gender: 'accessories' }
    },
    {
      path: '/en/accessories',
      name: 'Accessories-EN',
      component: Index,
      props: { lang: 'en', gender: 'accessories' }
    },
    {
      path: '/fr/',
      name: 'IndexFR',
      component: Index,
      props: { lang: 'fr', gender: 'women' }
    },
    {
      path: '/fr/hommes',
      name: 'MENFR',
      component: Index,
      props: { lang: 'fr', gender: 'men' }

    },
    {
      path: '/fr/hommes/hiver',
      name: 'MENFRWINTER',
      component: Index,
      props: { lang: 'fr', gender: 'men', season: 'winter' }

    },
    {
      path: '/fr/hommes/ete',
      name: 'MENFRSUMMER',
      component: Index,
      props: { lang: 'fr', gender: 'men', season: 'summer' }

    },
    {
      path: '/fr/enfants',
      name: 'KIDSFR',
      component: Index,
      props: { lang: 'fr', gender: 'kids' }

    },
    {
      path: '/fr/enfants/ete',
      name: 'KIDSFRSUMMER',
      component: Index,
      props: { lang: 'fr', gender: 'kids', season: 'summer' }

    },
    {
      path: '/fr/enfants/hiver',
      name: 'KIDSFRWINTER',
      component: Index,
      props: { lang: 'fr', gender: 'kids', season: 'winter' }

    },
    {
      path: '/fr/femmes',
      name: 'WOMENFR',
      component: Index,
      props: { lang: 'fr', gender: 'women' }

    },
    {
      path: '/fr/femmes/ete',
      name: 'WOMENFRSUMMER',
      component: Index,
      props: { lang: 'fr', gender: 'women', season: 'summer' }

    },
    {
      path: '/fr/femmes/hiver',
      name: 'WOMENFRWINTER',
      component: Index,
      props: { lang: 'fr', gender: 'women', season: 'winter' }

    },
    {
      path: '/fr/women/*',
      redirect: '/fr/femmes'
    },
    {
      path: '/fr/men/*',
      redirect: '/fr/hommes'
    },
    {
      path: '/fr/kids/*',
      redirect: '/fr/enfants'
    },
    {
      path: '/fr/dames/*',
      redirect: '/fr/femmes'
    },
    {
      path: '/fr/heren/*',
      redirect: '/fr/hommes'
    },
    {
      path: '/fr/kinderen/*',
      redirect: '/fr/enfants'
    },
    {
      path: '/fr/*',
      redirect: '/fr/'
    },
    {
      path: '/nl/',
      name: 'IndexNL',
      component: Index,
      props: { lang: 'nl', gender: 'women' }
    },
    {
      path: '/nl/heren',
      name: 'MENNL',
      component: Index,
      props: { lang: 'nl', gender: 'men' }

    },
    {
      path: '/nl/heren/winter',
      name: 'MENNLWINTER',
      component: Index,
      props: { lang: 'nl', gender: 'men', season: 'winter' }

    },
    {
      path: '/nl/heren/zomer',
      name: 'MENNLSUMMER',
      component: Index,
      props: { lang: 'nl', gender: 'men', season: 'summer' }

    },
    {
      path: '/nl/kinderen',
      name: 'KIDSNL',
      component: Index,
      props: { lang: 'nl', gender: 'kids' }

    },
    {
      path: '/nl/kinderen/zomer',
      name: 'KIDSNLSUMMER',
      component: Index,
      props: { lang: 'nl', gender: 'kids', season: 'summer' }

    },
    {
      path: '/nl/kinderen/winter',
      name: 'KIDSNLWINTER',
      component: Index,
      props: { lang: 'nl', gender: 'kids', season: 'winter' }

    },
    {
      path: '/nl/dames',
      name: 'WOMENNL',
      component: Index,
      props: { lang: 'nl', gender: 'women' }

    },
    {
      path: '/nl/dames/zomer',
      name: 'WOMENNLSUMMER',
      component: Index,
      props: { lang: 'nl', gender: 'women', season: 'summer' }

    },
    {
      path: '/nl/dames/winter',
      name: 'WOMENNLWINTER',
      component: Index,
      props: { lang: 'nl', gender: 'women', season: 'winter' }

    },
    {
      path: '/nl/women/*',
      redirect: '/nl/dames'
    },
    {
      path: '/nl/femmes/*',
      redirect: '/nl/dames'
    },
    {
      path: '/nl/men/*',
      redirect: '/nl/heren'
    },
    {
      path: '/nl/hommes/*',
      redirect: '/nl/heren'
    },
    {
      path: '/nl/kids/*',
      redirect: '/nl/kinderen'
    },
    {
      path: '/nl/enfants/*',
      redirect: '/nl/kinderen'
    },
    {
      path: '/nl/*',
      redirect: '/nl/'
    },
    {
      path: '/en/',
      name: 'IndexEN',
      component: Index,
      props: { lang: 'en', gender: 'women' }
    },
    {
      path: '/en/men',
      name: 'MENEN',
      component: Index,
      props: { lang: 'en', gender: 'men' }

    },
    {
      path: '/en/men/winter',
      name: 'MENENWINTER',
      component: Index,
      props: { lang: 'en', gender: 'men', season: 'winter' }

    },
    {
      path: '/en/men/summer',
      name: 'MENENSUMMER',
      component: Index,
      props: { lang: 'en', gender: 'men', season: 'summer' }

    },
    {
      path: '/en/kids',
      name: 'KIDSEN',
      component: Index,
      props: { lang: 'en', gender: 'kids' }

    },
    {
      path: '/en/kids/summer',
      name: 'KIDSENSUMMER',
      component: Index,
      props: { lang: 'en', gender: 'kids', season: 'summer' }

    },
    {
      path: '/en/kids/winter',
      name: 'KIDSENWINTER',
      component: Index,
      props: { lang: 'en', gender: 'kids', season: 'winter' }

    },
    {
      path: '/en/women',
      name: 'WOMENEN',
      component: Index,
      props: { lang: 'en', gender: 'women' }

    },
    {
      path: '/en/women/summer',
      name: 'WOMENENSUMMER',
      component: Index,
      props: { lang: 'en', gender: 'women', season: 'summer' }

    },
    {
      path: '/en/women/winter',
      name: 'WOMENENWINTER',
      component: Index,
      props: { lang: 'en', gender: 'women', season: 'winter' }

    },
    {
      path: '/en/femmes/*',
      redirect: '/en/women'
    },
    {
      path: '/en/dames/*',
      redirect: '/en/women'
    },
    {
      path: '/en/hommes/*',
      redirect: '/en/men'
    },
    {
      path: '/en/heren/*',
      redirect: '/en/men'
    },
    {
      path: '/en/kinderen/*',
      redirect: '/en/kids'
    },
    {
      path: '/en/enfants/*',
      redirect: '/en/kids'
    },
    {
      path: '/en/*',
      redirect: '/en/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js